export const WALLET_ACTIONS = {
    WALLET_SEARCH: 'WALLET_SEARCH',
    WALLET_SEARCH_SUCCESS: 'WALLET_SEARCH_SUCCESS',
    WALLET_SEARCH_ERROR: 'WALLET_SEARCH_ERROR',

    WALLET_UPSERT: 'WALLET_UPSERT',
    WALLET_UPSERT_SUCCESS: 'WALLET_UPSERT_SUCCESS',
    WALLET_UPSERT_ERROR: 'WALLET_UPSERT_ERROR',

    WALLET_EDIT: 'WALLET_EDIT',

    WALLET_BULK_UPDATE_TRANSACTIONS: 'WALLET_BULK_UPDATE_TRANSACTIONS',
    WALLET_BULK_UPDATE_TRANSACTIONS_SUCCESS: 'WALLET_BULK_UPDATE_TRANSACTIONS_SUCCESS',
    WALLET_BULK_UPDATE_TRANSACTIONS_ERROR: 'WALLET_BULK_UPDATE_TRANSACTIONS_ERROR',

    WALLET_RESET: 'WALLET_RESET',
};

export const walletResetAction = () => ({
    type: WALLET_ACTIONS.WALLET_RESET,
});

export const walletSearchAction = (payload) => ({
    type: WALLET_ACTIONS.WALLET_SEARCH,
    ...payload,
});

export const walletEditAction = (payload) => ({
    type: WALLET_ACTIONS.WALLET_EDIT,
    ...payload,
});

export const walletUpsertAction = (payload) => ({
    type: WALLET_ACTIONS.WALLET_UPSERT,
   ...payload,
});

export const walletBulkUpdateTransactionsAction = ({
    agentId,
    transactions,
}) => ({
    type: WALLET_ACTIONS.WALLET_BULK_UPDATE_TRANSACTIONS,
    agentId,
    transactions,
});

export default {
    WALLET_ACTIONS,
    walletSearchAction,
    walletUpsertAction,
    walletEditAction,
    walletBulkUpdateTransactionsAction,
    walletResetAction,
};
